import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService, SnackBarService } from 'src/app/services';

@Component({
  selector: 'app-setup-password',
  templateUrl: './confirm-account.component.html',
  styleUrls: ['./confirm-account.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ConfirmAccountComponent implements OnInit {
  private code: string = null;

  constructor(private router: Router, private route: ActivatedRoute, private authService: AuthService) { }

  // Validation errors
  public invalidCode: boolean = false;
  public accountConfirmed: boolean = false;

  public ngOnInit(): void {


    // Get query param
    this.code = this.route.snapshot.queryParams['code'];
    this.authService.confirmAccount(this.code).subscribe({
      next: () => {
        this.accountConfirmed = true;
      },
      error: (error) => {
        this.invalidCode = true;
      }
    })
  }

  public goToZilex() {
    window.open('https://zilex.de', '_blank');
  }
  public cancel(): void {
    this.router.navigate(["/login"]);
  }

}
